export default {
    init() {
    // JavaScript to be fired on the about us page
    const singleGlossaryCard = document.querySelectorAll('.single-glossary-card');

    singleGlossaryCard.forEach((e, idx) => {
      e.addEventListener('click', () => {
        singleGlossaryCard.forEach((element) => {
          element.classList.remove('open-glossary-card');
        });
        singleGlossaryCard[idx].classList.toggle('open-glossary-card');
        scrollIntoViewWithOffset(singleGlossaryCard[idx], 120);
      })
    });

    const scrollIntoViewWithOffset = (selector, offset) => {
      window.scrollTo({
        behavior: 'smooth',
        top:
          selector.getBoundingClientRect().top -
          document.body.getBoundingClientRect().top -
          offset,
      });
    }

    },
    finalize() {
      // JavaScript to be fired on all pages, after page specific JS is fired
    },
  };



// WEBPACK FOOTER //
// ./scripts/routes/glossary.js